import React from "react";
import Switch from "react-switch";
import {
    DeleteSvg,
    VendorDownloadSvg,
    VendorShareSvg,
    VendorInfoSvg,
    VendorKebabSvg,
} from "../../../components/CommonSvg";
import {
    fileKind,
    uploadedOn,
    ownerInitials,
} from "../../Vendor/Documents/documentUtils";

const DocumentListRow = ({
    row,
    showCategoryTag,
    statusUpdating,
    menuOpen,
    onToggleMenu,
    onDetails,
    onShare,
    onDownload,
    onDelete,
    onToggleStatus,
}) => {
    const kind = fileKind(row.documentName);
    const ownerName = row.owner || (row.uploadBy === "Admin" ? "You" : "Vendor");

    return (
        <div
            className={`doc-row${row.isActive ? "" : " off"}${
                menuOpen ? " menu-open" : ""
            }`}
        >
            <div className="doc-card-head">
                <span className={`doc-type-tag ${kind.cls}`}>{kind.label}</span>
                <div className="doc-card-title">
                    <h3 className="doc-fname">{row.documentName}</h3>
                    <div className="doc-metaline">
                        <span>{uploadedOn(row.createdDate)}</span>
                        {/* only a vendor's upload has one - an admin uploads on
                            HRA's own behalf */}
                        {row.ownerVendor && (
                            <span className="doc-vendor-tag" title={row.ownerVendor}>
                                {row.ownerVendor}
                            </span>
                        )}
                        {showCategoryTag && row.categoryName && (
                            <span className="doc-category-tag">{row.categoryName}</span>
                        )}
                    </div>
                </div>
                <div className="doc-actions">
                    <div className="doc-kebab-wrap">
                        <button
                            type="button"
                            className={`doc-kebab${menuOpen ? " open" : ""}`}
                            onClick={(event) => {
                                event.stopPropagation();
                                onToggleMenu(row);
                            }}
                        >
                            <VendorKebabSvg />
                        </button>

                        {menuOpen && (
                            <div
                                className="doc-kebab-menu"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <button type="button" onClick={() => onDetails(row)}>
                                    <VendorInfoSvg size={15} />
                                    Details
                                </button>
                                {row.uploadBy === "Admin" && row.isActive && (
                                    <button type="button" onClick={() => onShare(row)}>
                                        <VendorShareSvg size={15} />
                                        Share
                                    </button>
                                )}
                                <button type="button" onClick={() => onDownload(row)}>
                                    <VendorDownloadSvg size={15} />
                                    Download
                                </button>
                                {/* uploading is what grants the right to take a
                                    file down - the API refuses this for anyone
                                    else, so offering it would only be a dead
                                    end */}
                                {row.isOwnUpload && (
                                    <button
                                        type="button"
                                        className="danger"
                                        onClick={() => onDelete(row)}
                                    >
                                        <DeleteSvg />
                                        Delete
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="doc-card-foot">
                <div className="doc-owner">
                    {row.owner && (
                        <span
                            className={`doc-oav${
                                row.uploadBy === "Vendor" ? " admin" : ""
                            }`}
                        >
                            {ownerInitials(ownerName)}
                        </span>
                    )}
                    <span className="doc-oname">
                        {row.owner ? "Shared by " : "Uploaded by "}
                        <b>{ownerName}</b>
                    </span>
                </div>
                {/* the state is only shown where it can be changed - a bare
                    "Active" on someone else's upload was a label with nothing
                    to act on */}
                {row.isOwnUpload && (
                    <>
                        <span className="doc-stxt">
                            {row.isActive ? "Active" : "Inactive"}
                        </span>
                        <Switch
                            className={`react-switch switch-sm my-tooltip ${
                                row.isActive ? "isActive" : "false"
                            }`}
                            data-tooltip-content={row.isActive ? "Active" : "Inactive"}
                            onChange={() => onToggleStatus(row)}
                            type="checkbox"
                            checked={!!row.isActive}
                            disabled={statusUpdating}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default DocumentListRow;
